var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"id":"iiotLogin"}},[_c('v-col',{attrs:{"lg":"3","md":"5","sm":"12"}},[_vm._t("login-actions")],2),_c('v-col',{staticClass:"background"},[_c('background',{attrs:{"logo":_vm.logo,"image":_vm.image}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }